@if (admin && !isSimple) {
  <div class="box">
    <div class="content">
      <div class="member">
        <rt-avatar
          [type]="admin.hasAvatar ? 'image' : 'initials'"
          [initials]="admin.initials"
          [size]="'base'"
          [shape]="'oval'"
          [imageSrc]="admin.photoThumbUrl"
          context="admin"
        />
        <div layout layout-vertical>
          <div layout layout-align-items-center>
            <rt-heading> {{ admin.firstName }} {{ admin.lastName }} </rt-heading>
            <ng-container *ngTemplateOutlet="headingSlotTemplate" />
          </div>

          <span>{{ admin.roleName }}</span>
        </div>
      </div>
      @if (removable) {
        <div>
          <div [rtTooltip]="removeTooltipText">
            <rt-icon-button
              [loading]="adminInRemove === admin.id"
              (click)="removeFollower.emit(admin)"
              [disabled]="isDisabled"
              variant="plain"
              iconName="close"
              shape="square"
            />
          </div>
        </div>
      }
    </div>
  </div>
}

@if (admin && isSimple) {
  <div
    [attr.padding-left]="hasPadding ? '' : null"
    [class.has-checkbox-offset]="hasCheckboxOffset"
    class="box simple"
  >
    <div class="avatar" margin-right>
      <rt-avatar
        [type]="admin.hasAvatar ? 'image' : 'initials'"
        [initials]="admin.initials"
        [size]="'small'"
        [shape]="'oval'"
        [imageSrc]="admin.photoThumbUrl"
        context="admin"
      />
    </div>
    <div class="name" margin-left-small-xx layout-flex-1-0>
      {{ admin.firstName }} {{ admin.lastName }}
    </div>
  </div>
}

@if (roleWithAdmins) {
  <div [class.has-no-border-bottom]="hasNoBorderBottom" class="role-container">
    <div
      [class.has-padding]="hasPadding"
      [class.has-checkbox-offset]="hasCheckboxOffset"
      class="box role-box"
    >
      <div class="content">
        <div class="member">
          <div class="role-avatar">
            <rt-icon [name]="'people'" [size]="'small'" />
          </div>
          <div layout layout-vertical>
            <b>{{ roleWithAdmins.name }}</b>
            <span>{{ roleDescription }} </span>
          </div>
        </div>
        <div layout-horizontal>
          @if (hasManageSettingsButton) {
            <rt-icon-button
              (click)="goToManageRole.emit(roleWithAdmins.id)"
              variant="plain"
              shape="square"
              iconName="settings"
            />
          }
          @if (collapsable) {
            <rt-icon-button
              (click)="toggleList()"
              variant="plain"
              shape="square"
              [iconName]="expanded ? 'keyboard-arrow-up' : 'keyboard-arrow-down'"
            />
          }
        </div>
      </div>
    </div>
    @if (expanded) {
      @for (admin of roleWithAdmins.admins; track trackById($index, admin); let last = $last) {
        <rt-team-members-item
          [isSimple]="true"
          [isLast]="last"
          [admin]="admin"
          [hasPadding]="hasPadding"
          [hasCheckboxOffset]="hasCheckboxOffset"
          [removable]="false"
        />
      }
    }
  </div>
}
